// removed by extract-text-webpack-plugin
module.exports = {"cardWithOverflow":"ResetPasswordPage__cardWithOverflow--3DYKs","leftPaneWithOverflow":"ResetPasswordPage__leftPaneWithOverflow--ALGJs"};


//////////////////
// WEBPACK FOOTER
// ./src/client/src/components/pages/ResetPasswordPage.scss
// module id = 342
// module chunks = 0